import * as React from "react";
const SvgEmptyStar = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="m5.916 6.736.257-.037.118-.233L8 3.069l1.71 3.397.117.233.258.037 3.825.553-2.755 2.622-.193.184.045.263.642 3.74L8.23 12.32 8 12.202l-.23.119-3.441 1.776.663-3.737.047-.264-.194-.185L2.09 7.289l3.826-.553Z"
      stroke="currentColor"
    />
  </svg>
);
export default SvgEmptyStar;
